import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import ViewLoader from 'components/Loading/View';

const PartnerScheduleLiveClassDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: 'partner-schedule-live-class' */ 'components/Partner/ScheduleLiveClass'
    ),
);

const PartnerScheduleLiveClassView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={`${t('Schedule live class')} - Red Hat Learning`} />
      <React.Suspense fallback={<ViewLoader />}>
        <PartnerScheduleLiveClassDashboard />
      </React.Suspense>
    </>
  );
};

export default withErrorBoundary(
  observer(PartnerScheduleLiveClassView),
  GenericViewError,
  handleError,
);
